module.exports = __webpack_public_path__ + "static/media/bg_dark.36d1ae0e.jpg";